var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolvetechLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 41,
    viewBox: "0 0 140 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_10143)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3466 12.251C11.103 16.3034 -1.00345 28.1873 0.404273 31.6136L0.505341 31.8079C1.44382 33.4059 1.47992 33.4706 2.14408 34.32L3.04646 35.3925C-0.353732 30.7354 12.6262 17.2248 23.3466 12.251Z",
    fill: "url(#paint0_linear_134_10143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0989 12.5751C43.351 22.9187 38.3842 34.7449 28.0104 38.9846C17.6365 43.2242 5.78276 38.272 1.52349 27.9284C-2.72856 17.5777 2.23818 5.75866 12.612 1.51904C22.9859 -2.72057 34.8469 2.23164 39.0989 12.5751Z",
    fill: "url(#paint1_radial_134_10143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.695 9.25662C37.8136 16.8433 33.0923 25.9559 24.1551 29.6053C15.2106 33.2547 5.44318 30.066 2.32453 22.4793C-0.794122 14.8926 3.91995 5.7872 12.8644 2.13782C21.8017 -1.51156 31.5763 1.67715 34.695 9.26382V9.25662Z",
    fill: "url(#paint2_linear_134_10143)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M27.8152 5.20414C29.4034 9.06946 25.4401 14.3384 18.9718 16.9872C12.4963 19.6361 5.96297 18.6428 4.37477 14.7847C2.78657 10.9265 6.74985 5.65042 13.2254 3.00156C19.6937 0.359898 26.227 1.34602 27.8152 5.20414Z",
    fill: "url(#paint3_linear_134_10143)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9937 24.0413C18.1271 25.0274 18.1488 25.049 19.3977 26.1575C14.0844 29.9364 8.46798 32.6788 4.72849 33.5642C6.15065 34.9822 7.80382 36.1915 9.62303 37.1848C13.4419 36.3714 18.4015 34.3776 23.5992 31.4264C24.119 32.4557 24.2417 32.7148 24.747 33.8089C25.469 31.8079 25.6278 31.2392 26.0826 29.5621C26.5879 27.5611 26.6962 26.4022 26.8478 24.9338C26.2318 24.881 24.6171 24.7515 22.0038 24.5451C19.4266 24.3292 18.8418 24.2644 16.9937 24.0413Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2524 25.9631C24.9275 27.8994 24.812 28.5544 24.2562 30.8721C23.6714 29.6557 23.527 29.3678 22.9423 28.2305C14.0267 34.8814 5.65977 37.8974 3.04646 35.3997L2.14407 34.3272C1.0612 32.8084 1.01789 32.7436 0.505334 31.8151L0.404266 31.6207C2.13685 33.9889 10.7204 29.6413 18.4087 22.4937C17.0948 21.3132 17.066 21.2916 15.882 20.2335C17.7157 20.3775 18.3076 20.4135 20.856 20.507C23.4452 20.5838 25.0455 20.6342 25.6567 20.6582C25.6206 22.3353 25.5989 23.6598 25.2452 25.9631",
    fill: "url(#paint4_linear_134_10143)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3036 24.0484L45.336 23.4294C46.0651 24.761 46.9025 25.4305 47.8554 25.4305C48.2597 25.4305 48.6423 25.3369 49.0033 25.1497C49.3642 24.9626 49.6313 24.7035 49.819 24.3868C50.0067 24.07 50.1006 23.7317 50.1006 23.3718C50.1006 22.9688 49.9634 22.5657 49.6891 22.177C49.3065 21.6371 48.6134 20.9893 47.61 20.2335C46.5993 19.4705 45.964 18.9163 45.7186 18.578C45.2926 18.0093 45.0761 17.3903 45.0761 16.7281C45.0761 16.2026 45.206 15.7204 45.4587 15.2885C45.7113 14.8566 46.0651 14.5111 46.5271 14.2664C46.9891 14.0145 47.4872 13.8921 48.0287 13.8921C48.599 13.8921 49.1332 14.036 49.6313 14.3168C50.1294 14.5975 50.6564 15.1229 51.2123 15.8787L50.2233 16.6273C49.7685 16.0227 49.3786 15.6268 49.0538 15.4325C48.7289 15.2381 48.3824 15.1445 47.9998 15.1445C47.5089 15.1445 47.1119 15.2957 46.8014 15.5908C46.491 15.8859 46.3322 16.253 46.3322 16.6849C46.3322 16.9512 46.3899 17.2032 46.4982 17.4479C46.6065 17.6926 46.8086 17.9662 47.0974 18.2541C47.2562 18.4052 47.7832 18.8083 48.664 19.4633C49.7179 20.2407 50.4399 20.9245 50.8297 21.5292C51.2195 22.1338 51.4144 22.7384 51.4144 23.3502C51.4144 24.2284 51.0824 24.9914 50.411 25.6392C49.7396 26.287 48.9311 26.6109 47.9709 26.6109C47.2346 26.6109 46.5632 26.4166 45.964 26.0207C45.3648 25.6248 44.809 24.9698 44.3036 24.0484Z",
    fill: "#00437A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6116 13.8921C62.4524 13.8921 63.9901 14.5039 65.2318 15.7276C66.4735 16.9512 67.0943 18.4556 67.0943 20.2479C67.0943 22.0402 66.4735 23.523 65.239 24.7611C64.0046 25.9991 62.4958 26.6109 60.7126 26.6109C58.9295 26.6109 57.3919 25.9991 56.1502 24.7682C54.9085 23.5374 54.2949 22.0546 54.2949 20.3055C54.2949 19.1394 54.5764 18.0669 55.1395 17.0736C55.7026 16.0803 56.475 15.3029 57.4496 14.7415C58.4242 14.18 59.4782 13.8993 60.6116 13.8993V13.8921ZM60.6621 15.0726C59.7669 15.0726 58.9151 15.3029 58.1065 15.7708C57.298 16.2386 56.6699 16.8649 56.2224 17.6566C55.7676 18.4484 55.5438 19.3266 55.5438 20.2983C55.5438 21.7379 56.0419 22.9544 57.0453 23.9405C58.0488 24.9338 59.2544 25.4305 60.6621 25.4305C61.6078 25.4305 62.4741 25.2001 63.2826 24.7467C64.084 24.2932 64.712 23.667 65.1596 22.8752C65.6072 22.0834 65.831 21.2052 65.831 20.2407C65.831 19.2762 65.6072 18.4124 65.1596 17.635C64.712 16.8577 64.0767 16.2386 63.261 15.7708C62.4452 15.3029 61.5789 15.0726 60.6621 15.0726Z",
    fill: "#00437A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3646 14.1944H71.5774V25.1353H76.2481V26.3014H70.3646V14.1944Z",
    fill: "#00437A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1904 14.1944H77.5115L81.5397 23.5518L85.633 14.1944H86.9541L81.6697 26.3014H81.4026L76.1904 14.1944Z",
    fill: "#00437A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8417 14.1944H96.8009V15.3821H91.0545V19.1754H96.7504V20.3631H91.0545V25.1209H96.7504V26.3086H89.8417V14.1944Z",
    fill: "#00437A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4541 14.1944H105.168V16.469H102.952V26.3086H100.605V16.469H98.4469V14.1944H98.4541Z",
    fill: "#ED1C24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.608 14.1944H114.235V16.4474H109.904V18.6356H114.235V20.8525H109.904V24.0412H114.235V26.3086H107.608V14.1944Z",
    fill: "#ED1C24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.399 16.325L126.782 17.8654C125.685 16.7065 124.443 16.1235 123.071 16.1235C121.909 16.1235 120.934 16.5193 120.14 17.3111C119.346 18.1029 118.949 19.0746 118.949 20.2335C118.949 21.0397 119.122 21.7595 119.476 22.3857C119.83 23.0119 120.328 23.5014 120.97 23.8613C121.613 24.2212 122.328 24.3939 123.115 24.3939C123.786 24.3939 124.4 24.2716 124.955 24.0196C125.511 23.7677 126.118 23.3142 126.789 22.6592L128.356 24.2932C127.46 25.1641 126.609 25.7688 125.814 26.1071C125.013 26.4454 124.104 26.6109 123.078 26.6109C121.187 26.6109 119.642 26.0135 118.444 24.8186C117.238 23.6238 116.639 22.0978 116.639 20.2263C116.639 19.0171 116.913 17.9446 117.462 17.0088C118.011 16.0731 118.798 15.3173 119.815 14.7414C120.833 14.1728 121.938 13.8849 123.115 13.8849C124.118 13.8849 125.078 14.0936 126.009 14.5183C126.933 14.943 127.735 15.5404 128.406 16.3178L128.399 16.325Z",
    fill: "#ED1C24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.265 14.1944H133.611V18.7651H137.668V14.1944H140.007V26.3014H137.668V20.9893H133.611V26.3014H131.265V14.1944Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_10143",
    x1: 0.288768,
    y1: 23.8253,
    x2: 23.3394,
    y2: 23.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_134_10143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3076 20.2482) scale(20.3073 20.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#880102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_134_10143",
    x1: 25.7505,
    y1: 24.2428,
    x2: 9.41815,
    y2: 5.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_134_10143",
    x1: 19.0254,
    y1: 16.9342,
    x2: 13.3065,
    y2: 2.93517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_134_10143",
    x1: 24.4583,
    y1: 23.0551,
    x2: 1.722,
    y2: 36.0472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9FA2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_10143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 40.4959,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolvetechLogo);
export default __webpack_public_path__ + "static/media/solvetech_logo.e91c1a6b856513d7571692e3e84db46a.svg";
export { ForwardRef as ReactComponent };